export default {
  data(){
    return {
      getApi:'',
      saveApi:'',
      updateApi: '',
      deleteApi: '',
      selectedItems:[],
      checkedAll: '',
      searchModel: {text:null, type: null},
      selectedIndex: null,
      item: {},
      items: [],
      filter: [],
      paging: this.$dataProvider.paging,
      total: 0,
      dataLoadCount: 0,
      dataLoadInterval: null,


    }
  },
  mounted(){
    this.$on('dataTableFindStart', this.dataTableFindStart)
    this.$on('dataTableFindEnd', this.dataTableFindEnd)
  },

  computed: {

    getDate(){
      return (date) =>{
        return moment(date).format(this.dateFormat);
      }
    },
  },

  methods : {
    isSelected(){
      return this.items.filter((x)=> {return x.checked}).length != 0;
    },
    isSingleChecked() {
      return this.items.filter((x)=> {return x.checked}).length == 1;
    },

    dataTableFindStart(){
      var loadingText = '데이터 로딩중';
      this.dataLoadInterval = setInterval(function(){
        var textComma = '';
        for(var i = 0; i < this.dataLoadCount; i++){
          textComma += '.';
        }
        this.noDataText + textComma;
        if(this.dataLoadCount >=5)
          this.dataLoadCount = 0;
        else
          this.dataLoadCount++;
          this.noDataText = loadingText + textComma;
      }.bind(this), 1000)
    },
    dataTableFindEnd(){
      clearInterval(this.dataLoadInterval);
      this.noDataText = '데이터가 없습니다.';
    },
    check(){
      var that = this;
      that.items.forEach((item, index)=>{
        item.checked = that.checkedAll;
      });

      this.checkboxChange();
    },
    checkboxChange(){
      console.log(this.checkedAll);
      console.log(this.items.filter(item => !item.checked));
      if(this.items.filter(item => !item.checked).length > 0) this.checkedAll = false;
      else this.checkedAll = true;
      console.log(this.checkedAll);

      var selectedItems = _.filter(this.items, function(item){
        return item.checked;
      })
      this.selectedItems = [];
      this.selectedItems = selectedItems;
      this.$nextTick().then(() => {
        this.$forceUpdate();
      });
    },
    findAll(isUUID){
      this.$emit('dataTableFindStart')
      /*
      @RequestParam(required=false) String term,
			@RequestParam(required=false) String ids,
			@RequestParam(required=false) String offset,
			@RequestParam(required=false) String limit
      */

      //var payloadString = Object.entries(this.$route.query).map(e => e.join('=')).join('&');
      var that = this;
      setTimeout(()=>{
        var payloadString = $.param(that.$route.query);
        let url = '/api/private/' + that.getApi +'?'+ payloadString;
        if(that.getApi == 'board') url = '/api/public/' + that.getApi +'?'+ payloadString;

        that.$http.get(url)
          .then((result) => {
            that.resultData = result.data;
            that.items = result.data.list
            that.total = result.data.total;
            that.$emit('dataTableFindEnd')
          }).catch((e) =>{
            that.$emit('dataTableFindEnd')
            console.log(e);
        })
      },300)
    },
    search(param){

      var payloadString = Object.entries(param).map((e) => {
         if(e[1] != null) return e.join('=')
      }).join('&');

      console.log(payloadString);

      this.$http.get('/api/private/' + this.getApi +'?'+ payloadString)
        .then((result) => {

          this.resultData = result.data;
          this.items = result.data.list
          this.total = result.data.total;
          this.$emit('dataTableFindEnd')
        }).catch((e) =>{
        this.$emit('dataTableFindEnd')
        console.log(e);
      })

    },
    getItemById(id){
      var that = this;
      let url = '/api/private/' + this.getApi + '/' + id;
      if(that.getApi == 'board') url = '/api/public/' + this.getApi + '/' + id;
      this.$http.get(url)
        .then((result) => {

          this.item = result.data
        }).catch((e) =>{
          console.log(e);
      })
    },
    save(item){
      this.$http.post('/api/private/' + this.saveApi, [item])
        .then(function(result){
          // this.$toast.success('저장되었습니다.');
          this.noti('완료', '저장되었습니다.', 'success');
          this.findAll();
          this.selectedIndex = null;
        }.bind(this)).catch((e) =>{
          console.log(e);
      })
    },
    deleteItems(){
      this.$http.post('/api/private/'+ this.deleteApi, this.selectedItems)
        .then(function(result) {
          this.findAll();
        }.bind(this)).catch((e) =>{
          console.log(e);
      })
    },
    updateItems(){
      this.$http.post('/api/private/'+ this.updateApi, this.selectedItems)
        .then(function(result) {
          this.findAll();
        }.bind(this)).catch((e) =>{
          console.log(e);
      })
    }
  },

}
